import { createDocument, getAllData, updateDocumentByID } from 'apis/customApiHandler';
import Spinner from 'components/Spinner';
import Add from 'components/dtp-planning/add';
import ViewList from 'components/dtp-planning/viewList';
import useDebounce from 'hooks/useDebounce';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';
import { filterSelectStyles } from 'utils/reactSelectStyles';
import { Button, Input, Select } from 'styled';
import { TH } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import getFormattedDate from 'utils/helpers';
import permissions from 'utils/permissionConstants';
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import { useLocation } from 'react-router-dom';
import { trackSearchEvent, saveErrorCreationEvent, trackPageClickEvent } from 'utils/analytics';
import { ANALYTICS_EVENTS } from 'utils/analyticsEvents';


const DTPPlanning = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState('');
  // const [date, setDate] = useState()
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [status, setStatus] = useState()
  const [quarter, setQuarter] = useState("")
  const [plans, setPlans] = useState({})
  const [page, setPage] = useState(1);
  const currentUser = useSelector((state) => state.user.currentUser);
  // console.log(currentUser.userRole.permissions)
  const [selectedUsers, setSelectedUsers] = useState();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false)
  const [firstLoad, setFirstLoad] = useState(true)


  const { data: users } = useQuery([`/user`], () =>
  getAllData("/user/findFromPermission", {
    limit: 250,
    permissions: "view_dtp_plan"
    // searchQuery: "KAM"

  })
);

  
  const getUsers = useCallback(() => {
    if (users && users.data && users.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...users?.data?.map((user) => {
          return {
            value: user._id,
            label: user.name,
          };
        }),
      ];
    }
  }, [users]);

  const getData = async()=>{
    setIsLoading(true)
    try{

      const requestBody = {
        ...(status && { status }),
        ...(checkPermission([permissions.approve_dtp_plan], currentUser) && {
          ...(selectedUsers?.includes("all")
            ? {
                createdBy: getUsers()
                  .filter(
                    (item) =>
                      item.value !== "all" && item.value !== "clear"
                  )
                  .map((item) => item.value)
                  .join(","),
              }
            : selectedUsers.length && {
                createdBy: selectedUsers.map((fleet) => fleet).join(","),
              }),
        }),
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
        ...(quarter !== "" && { quarter }),
        limit: 20,
        page,
      };

      
      const response = await createDocument("/dtp-planning/getDtpPlanningData",requestBody);

  
      setPlans(response);
    } catch(err){
    }
    setIsLoading(false)
  }

  useEffect(()=>{
    if(!firstLoad) getData();
    else setFirstLoad(false)
  }, [page])


  function dtpApproveEventFunc(eventName, params) {
    return saveErrorCreationEvent(eventName, "Approve DTP Plan", "DTP Planning", location.pathname, params);
  }

  const approveRequest = async(id)=>{
    setIsLoading(true)
    try{
      dtpApproveEventFunc(ANALYTICS_EVENTS.CLICK_APPROVE_BUTTON, { approved_dtp_id: id });
      const response = await updateDocumentByID("dtp-planning", id, {status: "Approved"})
      if(response?.data){
        dtpApproveEventFunc(ANALYTICS_EVENTS.SYS_APPROVE_DTP_PLANNING_SUCCESS, { approved_dtp_id: id });
        toast.success(response.message)
      }
      getData()
    } catch(err){
      const errMsg = err?.response?.data?.message || err?.message;
      dtpApproveEventFunc(ANALYTICS_EVENTS.SYS_APPROVE_DTP_PLANNING_ERROR, { approved_dtp_id: id, errMsg });
      toast.error(err?.message??"Some Error Occured")
    }
    setIsLoading(false)
  }

  const clickSearchBtn = () => {
    const params = {
      from_date: dateFrom,
      to_date: dateTo,
      kam: selectedUsers?.includes("all")
        ? "All"
        : selectedUsers?.map((id) => getUsers()?.find((item) => item.value === id)?.label ?? id),
      quarter: quarter || "All",
      status: status || "All",
    };

    trackSearchEvent(ANALYTICS_EVENTS.CLICK_SEARCH_BUTTON, "DTP Planning", location.pathname, params);
  };

  return (
    <div>
      <div className="mx-10 my-2">
        <div className="mt-8 flex justify-start gap-6 items-end flex-wrap lg:flex-nowrap">
          
        <label className="w-full py-3 flex flex-col gap-2">
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            End Date{" "}
            <Input
              type="date"
              min={getFormattedDate(dateFrom)}
              max={getFormattedDate(new Date())}
              // max={getFormattedDate(new Date(Math.max(new Date().getTime(), new Date(dateFrom)?.getTime())))}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>
          {checkPermission([permissions.approve_dtp_plan], currentUser) && <label className="w-full py-3 flex flex-col gap-2">
            KAM
            <ReactSelect
              styles={filterSelectStyles}
              className="shadow-md rounded-md"
              options={getUsers()}
              value={
                selectedUsers &&
                selectedUsers?.map((user) => {
                  return {
                    value: user,
                    // label: users?.data?.find((item) => item?._id === user)
                    //   ?.name,
                    label: getUsers()?.find((item) => item?.value === user)
                    ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                if(allValues?.includes("clear")){
                  setSelectedUsers([]);
                  return;
                }
                if(!selectedUsers?.includes("all") && allValues.includes("all")){
                  setSelectedUsers(["all"]);
                  return;
                }
                if (allValues.includes("all")) {
                  setSelectedUsers(
                    users?.data?.map((item) => {
                      return item._id;
                    })
                  );
                } else {
                  setSelectedUsers(value.map((user) => user.value));
                }
              }}
              name="users"
              isMulti={true}
              isClearable={false}
            />
          </label>}
          <label className="w-full py-3 flex flex-col gap-2">
            Quarter
            <Select
              name="quarter"
              value={quarter}
              onChange={(e) => setQuarter(e.target.value)}
            >
              <option value={""}>All</option>
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
            </Select>
          </label>

          <label className="w-full py-3 flex flex-col gap-2">
            Status
            <Select
              name="status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">All</option>
              <option value="Approved">Approved</option>
              <option value="Created">Created</option>
            </Select>
          </label>

        <div className="flex flex-wrap justify-start items-end gap-4 mb-3">
          <Button
            type="button"
            // disabled={!.length}
            bgPrimary
            onClick={() => {
              clickSearchBtn();
              getData();
            }}
          >
            Search
          </Button>
          <Button
            className="!px-8 disabled:bg-gray-400"
            bgPrimary
            disabled={!checkPermission([permissions.create_dtp_plan], currentUser)}
            onClick={() => setShowAddmodel(true)}
          >
            Add
          </Button>
        </div>



         
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">KAM</TH>
                      <TH scope="col">Quarter</TH>
                      <TH scope="col">Created At</TH>
                      <TH scope="col">Status</TH>
                      <TH scope="col">Actions</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {plans?.data &&
                      plans?.data.map((data, index) => (
                        <ViewList
                          data={data}
                          key={data._id}
                          index={index}
                          approveRequest={approveRequest}
                          getData={getData}
                          page={page}
                          setPage={setPage}
                        />
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
            {plans && plans.paginate && plans.paginate.totalData && (
        <div className="container mx-auto flex justify-center items-center gap-2 py-5">
          <Button
            onClick={() => {
              trackPageClickEvent(ANALYTICS_EVENTS.CLICK_PREVIOUS_PAGE_BUTTON, "DTP Planning", location.pathname);
              setPage((p) => Math.max(p - 1, 1));
            }}
            disabled={page === 1}
            className="disabled:pointer-events-none disabled:opacity-70 px-0 "
            primary
          >
            <div className="flex gap-1 items-center">
              <IoMdArrowBack />
              Prev Page
            </div>
          </Button>
          <span className="text-gray-600 px-4">{`showing: ${
            (page - 1) * 20 + 1
          } - ${Math.min(plans?.paginate?.totalData, page * 20)} of ${
            plans.paginate.totalData
          }`}</span>

          {plans.paginate.totalData > page * 20 && (
            <Button
              onClick={() => {
                trackPageClickEvent(ANALYTICS_EVENTS.CLICK_NEXT_PAGE_BUTTON, "DTP Planning", location.pathname);
                setPage((p) => Math.min(p + 1, plans?.paginate?.totalPage));
              }}
              disabled={page === plans?.paginate?.totalPage}
              className="disabled:pointer-events-none disabled:opacity-70 px-0 "
              primary
            >
              <div className="flex gap-1 items-center">
                Next Page
                <IoMdArrowForward />
              </div>
            </Button>
          )}
        </div>
      )}
          </div>
        </div>
      )}
      {showAddmodel && <Add 
      getData= {getData} 
      handleClick={() => {setShowAddmodel(false);
      }} />}
    </div>
  );
};

export default DTPPlanning;
